module.exports = __webpack_public_path__ + "img/middleCarouseImg.e02ec484.jpg";